import useIsGoStudentLearningApp from "features/goStudentLearning/hooks/useIsGoStudentLearningApp";
import { useIsPlurallApp } from "features/plurall";

import SignUpCardGoStudentLearning from "../apps/SignUpCardGoStudentLearning";
import SignUpCardPlurallApp from "../apps/SignUpCardPlurallApp";
import SignUpCardStandard from "../apps/SignUpCardStandard";

export type SignUpCardAppsContainerProps = {
  linkToSignIn: string;
  linkToNextPage?: string;
  linkToNextPageSSO?: string;
  redirectAuthenticatedUserTo?: string;
  accountType?: string;
};

export default function SignUpCardContainer(
  props: SignUpCardAppsContainerProps
) {
  const isPlurallApp = useIsPlurallApp();
  const isGoStudentLearningApp = useIsGoStudentLearningApp();

  return (
    <>
      {isGoStudentLearningApp ? (
        <SignUpCardGoStudentLearning {...props} />
      ) : isPlurallApp ? (
        <SignUpCardPlurallApp {...props} />
      ) : (
        <SignUpCardStandard {...props} />
      )}
    </>
  );
}
